import { render, staticRenderFns } from "./AiProviderManager.vue?vue&type=template&id=c84da9a4"
import script from "./AiProviderManager.vue?vue&type=script&lang=ts"
export * from "./AiProviderManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports